import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-exportoptionpopup',
  templateUrl: './exportoptionpopup.component.html'
})
export class ExportoptionpopupComponent implements OnInit {

  errorMsg: string = '';
  HeaderDataLength: number = 0;
  exportoptionform: FormGroup;

  constructor(private form: FormBuilder, public dialogRef: MatDialogRef<ExportoptionpopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.HeaderDataLength = data.HeaderDataLength;
    }
  }

  ngOnInit(): void {
    this.exportoptionform = this.form.group({
      ExportType: ['', [Validators.required]],
    });
  }

  // Export button click
  Export() {
    this.dialogRef.close(this.exportoptionform.value.ExportType);
  }

  // Close icon click
  Close() {
    this.dialogRef.close();
  }

  // On change Radio button click
  onChange(radiobtnVal: any) {
    this.errorMsg = '';
    if (radiobtnVal == 'PDF' && this.HeaderDataLength > 6) {
      this.errorMsg = 'Maximum 6 Parameters are needed to export the PDF!!';
      this.exportoptionform.patchValue({
        ExportType: 'Excel'
      });
      return;
    }
  }

}
